module.exports = __webpack_public_path__ + "img/fig_rosalee_fr.5489b502.png";